import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFoundPage() {
    return (
        <section
            data-testid="not-found-page"
            className="bg-white border-b border-slate-200"
        >
            <div className="max-w-3xl mx-auto px-6 md:px-12 py-24 md:py-32 text-center">
                <p className="eyebrow">404</p>
                <h1
                    data-testid="not-found-headline"
                    className="mt-4 font-display text-4xl md:text-6xl font-semibold tracking-tighter text-slate-900 leading-[1.05]"
                >
                    Page not found.
                </h1>
                <p className="mt-5 text-base md:text-lg text-slate-600 leading-relaxed">
                    The page you&rsquo;re looking for doesn&rsquo;t exist or may have
                    moved. Try one of the links below.
                </p>
                <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
                    <Link
                        to="/"
                        data-testid="not-found-home-btn"
                        className="inline-flex items-center justify-center gap-2 bg-slate-900 text-white text-sm md:text-base font-medium px-7 py-3.5 rounded-md hover:bg-slate-800 transition-colors"
                    >
                        Back to home
                        <ArrowRight size={16} />
                    </Link>
                    <Link
                        to="/inducext"
                        data-testid="not-found-inducext-btn"
                        className="inline-flex items-center justify-center gap-2 bg-white text-slate-900 border border-slate-300 text-sm md:text-base font-medium px-7 py-3.5 rounded-md hover:border-slate-900 transition-colors"
                    >
                        Induce XT overview
                        <ArrowRight size={16} />
                    </Link>
                </div>
            </div>
        </section>
    );
}
